import { Input } from '@/components/ui/input';
import { SearchIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type CustomerIdentitySearchProps = {
  value: string;
  onChange: (value: string) => void;
};

export const CustomerIdentitySearch = ({ value, onChange }: CustomerIdentitySearchProps) => {
  const { t } = useTranslation();

  return (
    <Input
      size="sm"
      value={value}
      type="search"
      aria-label={t('searchTenants')}
      placeholder={t('searchTenants')}
      className="h-9 rounded-sm border-background-darker text-md font-normal leading-6 placeholder:text-text-secondary focus-visible:border-2 focus-visible:border-primary-light focus-visible:ring-primary-light/20"
      startIcon={<SearchIcon aria-hidden="true" className="size-4 text-text-secondary" />}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
